// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import store from '../../store.js';
import {P_METHOD_META} from '../../utils/constants.js';
import {Text} from '../text';
import {Icon} from '../icon';
import {Countdown} from '../countdown';
import {Popup_btn as Redeem_cfg_btn} from '../../features/redeem';
import * as cns from './redeem_details.module.less';

function Tip({meta}){
    return <Text.s>
      Email is{' '}
      <Text.s span bold>{meta.redeem_details.email}</Text.s>
    </Text.s>;
}

function Counter({meta}){
    const {balance, redeem_details} = meta;
    if (balance<redeem_details.min_redeem)
        return null;
    return <div className={cns.cd_row}>
      <Text.xs tertiary span>Next auto-redeem in:{' '}</Text.xs>
      <Countdown className={cns.counter} counter="auto_redeem" size="s"/>
    </div>;
}

export function Redeem_details({className}){
    const [money] = store.use_money();
    const method = money.redeem_details?.payment_method;
    const is_set = !!method;
    const meta = P_METHOD_META[method];
    const tip = is_set ? <Tip meta={money}/> : null;
    return <div className={cn('ea_redeem_details', className)}>
      <div className={cns.row}>
        <div className={cns.ico_wrap}>
          <Icon ico="refresh" color="accent" size="xl"/>
        </div>
        <div className={cns.value_wrap}>
          <Text.s tertiary>Auto-redeem</Text.s>
          <div className={cns.value_row}>
            <Text.l className={cns.value} span bold={is_set} tip={tip}
              secondary={!is_set}>
              {is_set
                ? meta?.title || method
                : 'Not set'
              }
            </Text.l>
            <Redeem_cfg_btn/>
          </div>
        </div>
      </div>
      {!!money.redeem_details&&<Counter meta={money}/>}
    </div>;
}
